import { ShieldCheck } from "lucide-react";
import { inputCls, labelCls } from "./constants";

export default function RodoSection({ pages, setPages }) {
  const rodo = pages.rodo || {};
  const update = (field, value) =>
    setPages({ ...pages, rodo: { ...rodo, [field]: value } });

  return (
    <section>
      <h3 className="flex items-center gap-2 font-bold text-slate-800 text-lg mb-4">
        <ShieldCheck size={18} className="text-[#1f3a8a]" /> RODO – klauzula informacyjna
      </h3>
      <div className="rounded-xl border border-slate-200 p-5 bg-slate-50/50 space-y-4">
        <div className="grid md:grid-cols-2 gap-3">
          <div>
            <label className={labelCls}>Tytuł</label>
            <input
              data-testid="rodo-edit-title"
              className={inputCls}
              value={rodo.title || ""}
              onChange={(e) => update("title", e.target.value)}
            />
          </div>
          <div>
            <label className={labelCls}>Podtytuł</label>
            <input
              data-testid="rodo-edit-subtitle"
              className={inputCls}
              value={rodo.subtitle || ""}
              onChange={(e) => update("subtitle", e.target.value)}
            />
          </div>
        </div>
        <div>
          <label className={labelCls}>Wstęp (jeden akapit, wyróżniony)</label>
          <textarea
            data-testid="rodo-edit-intro"
            className={inputCls}
            rows={4}
            value={rodo.intro || ""}
            onChange={(e) => update("intro", e.target.value)}
          />
        </div>
        <div>
          <label className={labelCls}>Treść klauzuli</label>
          <p className="text-xs text-slate-500 mb-2">
            Nowe linie oraz odstępy są zachowywane 1:1. Wpisuj punkty ręcznie
            (np. „1)", „2)", „a)", „b)"). Puste linie tworzą odstępy między punktami.
          </p>
          <textarea
            data-testid="rodo-edit-body"
            className={`${inputCls} font-mono text-xs leading-relaxed`}
            rows={22}
            value={rodo.body || ""}
            onChange={(e) => update("body", e.target.value)}
          />
        </div>
      </div>
    </section>
  );
}
